import { ReactSDKClient } from '@optimizely/react-sdk';
import { useSelector } from 'react-redux';
import {
    getOptimizelyFeatureFlag,
    selectForcedFeatures
} from 'shared/optimizely';

const useOptimizely = (
    optimizely: ReactSDKClient | null,
    featureKey: string
) => {
    const featureFlagOverrides = useSelector(selectForcedFeatures);

    return getOptimizelyFeatureFlag(
        featureKey,
        featureFlagOverrides,
        optimizely
    );
};

export default useOptimizely;
